var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPosts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M436.783,0H75.217C64.314,0,55.476,8.839,55.476,19.741v472.518 c0,10.902,8.839,19.741,19.741,19.741h361.567c10.902,0,19.741-8.839,19.741-19.741V19.741C456.524,8.839,447.686,0,436.783,0z  M94.957,39.482h322.085V294.76l-62.267-67.895c-6.17-6.725-16.141-8.345-24.125-3.921l-75.047,41.628l-105.625-53.8 c-8.157-4.154-18.101-2.156-24.019,4.827l-31.002,36.584V39.482z M417.044,472.517H94.957V313.249l51.023-60.207l101.06,51.475 c5.849,2.978,12.795,2.857,18.537-0.328l70.62-39.172l80.847,88.155V472.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M141.021,173.34h229.96c10.902,0,19.741-8.839,19.741-19.741V85.544 c0-10.902-8.839-19.741-19.741-19.741h-229.96c-10.902,0-19.741,8.839-19.741,19.741V153.6 C121.28,164.502,130.117,173.34,141.021,173.34z M160.762,105.285H351.24v28.574H160.762V105.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M254.202,344.844H141.021c-10.902,0-19.741,8.839-19.741,19.741s8.839,19.741,19.741,19.741 h113.181c10.902,0,19.741-8.839,19.741-19.741C273.943,353.682,265.104,344.844,254.202,344.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M254.202,403.398H141.021c-10.902,0-19.741,8.839-19.741,19.741s8.839,19.741,19.741,19.741 h113.181c10.902,0,19.741-8.839,19.741-19.741S265.104,403.398,254.202,403.398z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPosts);
export default __webpack_public_path__ + "static/media/userPosts.a88f07b6c6372cb4e7a0b6fd0822c3d5.svg";
export { ForwardRef as ReactComponent };